import React, { useState } from 'react';
import cn from 'classnames';
import { Icon, LazyImage } from '@landing/ui';
import { useWindowResize } from 'utils/hooks';

import * as styles from './Slide.module.scss';

export default function Slide({ title, description, img, name, position, linkedin }) {
  const { width } = useWindowResize();
  const [showAllDescription, setShowAllDescription] = useState(false);
  const mobileDescription = width < 545 && !showAllDescription;

  return (
    <div className={styles.slide}>
      <p className={styles.title}>"{title}"</p>
      <p className={styles.description}>
        {mobileDescription ? (
          <>
            {description.slice(0, 157)}
            <span
              className={cn(styles.moreButton, showAllDescription && styles.hidden)}
              role="button"
              onClick={() => setShowAllDescription(true)}
            >
              Show more...
            </span>
          </>
        ) : (
          description
        )}
      </p>
      <figure className={styles.figure}>
        <LazyImage className={styles.img} src={img} />
        <figcaption>
          <a
            className={styles.link}
            href={linkedin}
            target="_blank"
            rel="noreferrer noopener noindex nofollow"
          >
            <span className={styles.name}>{name}</span>{' '}
            <Icon className={styles.linkedinIcon} name="linkedin" />
          </a>
          <p className={styles.position}>{position}</p>
        </figcaption>
      </figure>
    </div>
  );
}
